import { render, staticRenderFns } from "./CreateOrderModalPassiveStock.vue?vue&type=template&id=71d0e76a&scoped=true"
import script from "./CreateOrderModalPassiveStock.vue?vue&type=script&lang=js"
export * from "./CreateOrderModalPassiveStock.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderModalPassiveStock.vue?vue&type=style&index=0&id=71d0e76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0e76a",
  null
  
)

export default component.exports